import React from 'react';
import { Dialog } from '../../../../Components/MUIs';
import './LEG_BASIC_LawSelectDialog.styles.css';

/** 법규준수평가 — 이미 등록된 점검표 안내 팝업 */
function LEG_BASIC_ExistingEvalDialog({
  open = false,
  lawNm = '',
  mode = 'confirmed',
  onClose = () => {},
  onConfirm = () => {},
}) {
  const name = String(lawNm ?? '').trim();
  const isDraft = mode === 'draft';

  return (
    <Dialog
      open={open}
      onClose={onClose}
      title={isDraft ? '임시저장된 점검표' : '이미 저장된 점검표'}
      maxWidth="sm"
      fullWidth
      useSaveButton={true}
      useCloseButton={true}
      saveButtonName={isDraft ? '이어서 작성' : '확인'}
      closeButtonName="닫기"
      onSave={onConfirm}
      titleSx={{ pb: 1, fontWeight: 700, fontSize: 18 }}
      contentSx={{ pt: 4, px: 2.5, pb: 2.5 }}
      content={
        <div className="leg-law-select">
          <div className="leg-law-select__intro leg-law-select__intro--notice">
            <div className="leg-law-select__intro-icon leg-law-select__intro-icon--notice">
              <span className="material-symbols-outlined">info</span>
            </div>
            <div>
              <div className="leg-law-select__intro-title">
                {isDraft
                  ? '임시저장된 점검표가 있습니다'
                  : '저장완료된 점검표가 있습니다'}
              </div>
              <p className="leg-law-select__intro-desc">
                {isDraft
                  ? '이어서 작성을 선택하면 임시저장된 점검표를 수정할 수 있습니다.'
                  : '저장완료된 점검표는 수정할 수 없습니다. 기본정보 목록에서 조회·삭제만 가능합니다.'}
              </p>
            </div>
          </div>

          {name ? (
            <div className="leg-law-select__card leg-law-select__card--custom leg-law-select__card--static">
              <div className="leg-law-select__card-main">
                <div className="leg-law-select__card-icon">
                  <span className="material-symbols-outlined">menu_book</span>
                </div>
                <div className="leg-law-select__card-body">
                  <div className="leg-law-select__card-top">
                    <span className="leg-law-select__card-title">{name}</span>
                    <span
                      className={`leg-law-select__badge ${
                        isDraft
                          ? 'leg-law-select__badge--draft'
                          : 'leg-law-select__badge--saved'
                      }`}
                    >
                      {isDraft ? '임시저장' : '저장완료'}
                    </span>
                  </div>
                  <p className="leg-law-select__card-desc">
                    {isDraft
                      ? '작성 중인 점검표입니다. 이어서 작성하거나 목록에서 열 수 있습니다.'
                      : '기본정보 목록에서 이 법령 점검표를 열어 조회할 수 있습니다.'}
                  </p>
                </div>
              </div>
            </div>
          ) : null}
        </div>
      }
    />
  );
}

export default LEG_BASIC_ExistingEvalDialog;
